import { formatDateString } from '../../../../utils/date/date';
import Text from '../../../Text/Text';
import { getFormattedDate } from '../../DatePickerUtils/DatePickerUtils';

const DisplayDate = ({
  day,
  month,
  year,
  initialPlaceholder,
  placeholder,
  setPlaceholder,
  disabled,
  dateFormat,
}: {
  day?: number;
  month?: number;
  year?: number;
  placeholder?: string;
  disabled?: boolean;
  dateFormat?: 'long' | 'medium' | 'short';
  initialPlaceholder?: string;
  setPlaceholder?: React.Dispatch<React.SetStateAction<string | undefined>>;
}) => {
  if (!day || month === null || month === undefined || !year) {
    // reset placeholder to initial value and display placeholder in place of date value if passed in date prop in DatePicker.jsx is null,
    // not ideal but currently this DatePicker.jsx has no way to officially reset date value to null

    setPlaceholder?.(initialPlaceholder);

    if (placeholder && placeholder !== '') {
      return (
        <span
          className={`selected-value body${placeholder !== '' && !disabled ? ' placeholder' : ''}`}
        >
          <Text type="body">{placeholder}</Text>
        </span>
      );
    }
  }

  const formattedDate = getFormattedDate(day, month, year);

  if (
    dateFormat === 'short' &&
    (formattedDate?.split(' ')[0] === 'Today' || formattedDate?.split(' ')[0] === 'Tomorrow')
  ) {
    const weekDay = formattedDate.split(' ')[0];
    const dateWithoutWeekDay = formattedDate.split(' ').slice(1).join(' ');

    return (
      <span className={'selected-value body'}>
        <Text type="body">
          {weekDay}

          <span className="selected-value body placeholder">{dateWithoutWeekDay}</span>
        </Text>
      </span>
    );
  }

  if (dateFormat === 'short') {
    return (
      // @ts-expect-error Fix this
      <span className={'selected-value body'}>{formatDateString(new Date(year, month, day))}</span>
    );
  }

  if (
    dateFormat === 'medium' &&
    (formattedDate?.split(' ')[0] === 'Today' || formattedDate?.split(' ')[0] === 'Tomorrow')
  ) {
    const weekDay = formattedDate.split(' ')[0];

    return (
      <span className={'selected-value body'}>
        {weekDay + ' '}
        <span className="selected-value body placeholder">
          {/* @ts-expect-error Fix this */}
          {formatDateString(new Date(year, month, day))}
        </span>
      </span>
    );
  }

  return <span className={'selected-value body'}>{formattedDate}</span>;
};

export default DisplayDate;
